import React from 'react';

const BenefitCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="bg-aug-cream rounded-xl p-6 hover:bg-white hover:shadow-lg transition-all duration-300">
      <div className="w-12 h-12 bg-aug-green-light rounded-lg flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-aug-green" />
      </div>
      <h3 className="text-xl font-semibold text-aug-gray-dark mb-2">{title}</h3>
      <p className="text-aug-gray-medium leading-relaxed">{description}</p>
    </div>
  );
};

export default BenefitCard;